import client from './client';
import qs from 'qs';

/**
 * 매출관리 - 통합매출관리
 */
export const salesCalculateReport = (params) =>
  client.get(`/api/calculate/report`, params);

/**
 * 매출관리 - 통합매출관리 - 메모 (히스토리)
 */
export const salesCalculateReportMemo = (params) =>
  client.get(`/api/calculate/report/memo`, params);

/**
 * 매출관리 - 통합매출관리 - 메모 (히스토리- 등록)
 */
export const salesCalculateReportMemoSet = (params) =>
  client.post(`/api/calculate/report/memo/set`, qs.stringify(params));

/**
 * 매출관리 - 통합매출관리 - 메모 (히스토리- 등록)
 */
export const salesCalculateReportMemoModify = (params) =>
  client.post(`/api/calculate/report/memo/modify`, qs.stringify(params));

/**
 * 매출관리 - 통합매출관리 (통합매출보고서 각종 금액 수기입력)
 * @param {array}
 */
export const calculatePriceSet = (params) =>
  client.post(`/api/calculate/report/price/set`, qs.stringify(params));

/**
 * 매출관리 - 통합매출관리 - 외부연동 - 연동사별리포트 (금액 수기입력)
 * @param {array}
 */
export const calculateExlPriceSet = (params) =>
  client.post(`/api/calculate/report/exlPrice/set`, qs.stringify(params));

/**
 * 매출관리 - 세금계산서 엑셀 업로드
 */
export const calculateReportUpload = (params) =>
  client.post(`/api/calculate/report/upload`, qs.stringify(params));

/**
 * 매출관리 - 외부연동 (연동사 세금계산서 엑셀 업로드)
 */
export const calculateReportExlUpload = (params) =>
  client.post(`/api/calculate/report/exl/upload`, qs.stringify(params));

/**
 * 매출관리 - 매출관리
 */
export const salesData = (params) =>
  client.get(`/api/manage/sales/report`, { params: params });

/**
 * 매출관리 - 통합매출관리 - 외부연동 (연동사리포트,)
 */
export const salesCalculateReportExl = (params) =>
  client.get(`/api/calculate/report/exl`, params);

/**
 * 매출관리 - 매출내역
 */
export const salesStatistics = (params) =>
  client.get(`/api/manage/sales/list`, params);

/**
 * 매출관리 - 매출합계
 */
export const payTypeTot = (params) =>
  client.get(`/api/manage/sales/totPayType`, { params: params });

/**
 * 매출관리 - 매출내역
 */
export const payTypeList = (params) => client.get(`/api/code/payType`, params);

/**
 * 매출관리 - 홀로그램 배너
 */
 export const hologramBanner = (params) => client.get(`/api/manage/sales/hologramBanner`, params);

 /**
  * 매출관리 - 홀로그램 배너 - 팝업
*/
  export const hologramPopup = (params) => client.get(`/api/manage/sales/hologramBanner/popup`, params);

/**
 * 보너스 포인트로그 수정
 * @param {array}
 */
export const modifyBonusPointLog = (no, restRsnCode, memo, payType) =>
  client.post(
    `/api/manage/sales/modify`,
    qs.stringify({
      no: no,
      restRsnCode: restRsnCode,
      memo: memo,
      payType: payType,
    })
  );

/**
 * 포인트로그 수정
 * @param {array}
 */
export const modifyPointLog = (
  orderNumber,
  depositor,
  revenuePoint,
  payType,
  memo
) =>
  client.post(
    `/api/manage/sales/modify`,
    qs.stringify({
      orderNumber: orderNumber,
      revenuePoint: revenuePoint,
      payType: payType,
      memo: memo,
      depositor: depositor,
    })
  );

/**
 * 매출관리 - 포인트관리
 */
export const pointData = (params) =>
  client.get(`/api/manage/sales/point/month`, { params: params });

/**
 * 매출관리 - 포인트 사유별 합계
 */
export const reasonTot = (params) =>
  client.get(`/api/manage/sales/point/totReason`, { params: params });

/**
 * 매출관리 - 포인트사유
 */
export const reasonList = (params) => client.get(`/api/code/reason`, params);

/**
 * 매출관리 - 포인트 내역
 */
export const pointStatistics = (params) =>
  client.get(`/api/manage/sales/point/list`, params);

/**
 * 매출관리 - 가상계좌 상태
 */
export const viAccountStatistics = (params) =>
  client.get(`/api/report/viaccount/state`, params);

/**
 * 매출관리 - 가상계좌 상태 합계
 */
export const viAccountTot = (params) =>
  client.get(`/api/report/viaccount/state/total`, { params: params });

/**
 * 매출관리 - 가상계좌 목록
 */
export const viAccountList = (params) =>
  client.get(`/api/report/viaccount`, params);

/**
 * 매출관리 - 가상계좌 수
 */
export const viAccountListCount = (params) =>
  client.get(`/api/report/viaccount/count`, { params: params });

/**
 * 매출관리 - EP 정산 데이터
 */
export const epApiData = (params) =>
  client.get(`/api/manage/sales/epCalculate`, params);

/**
 * 매출관리 - EP 정산 데이터 - 상세
 */
export const epApiDetailData = (params) =>
  client.get(`/api/manage/sales/epCalculate/detail`, params);

/**
 * 매출관리 - EP 정산 데이터 - 상세
 */
export const postpayData = (params) =>
  client.get(`/api/manage/sales/postpay`, params);
